import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatCardModule} from '@angular/material/card';

import { MatDatepickerModule } from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';

import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '@atmi/shared';
import { UiModule } from '@ui/ui.module';

import { AuditsFiltersComponent } from './components/audits-filters/audits-filters.component';
import { AuditsComponent } from './components/audits/audits.component';
import { AuditModuleConfiguration } from './models/configuration';
import { AuditsApiService } from './services/audits-api.service';
import { AuditConfigurationService } from './token';

export * from './components/audits/audits.component';
export * from './models/configuration';
export * from './models/audit';
export * from './services/audits-api.service';
export * from './token';

const routes: Routes = [
  {
    children: [
      {
        component: AuditsComponent,
        path: '',
      },
    ],
    path: '',
  },
];

@NgModule({
  declarations: [
    AuditsComponent,
    AuditsFiltersComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    SharedModule,
    TranslateModule,
    UiModule,
  ],
})
export class AuditModule {
  static forRoot(config: AuditModuleConfiguration): ModuleWithProviders<AuditModule> {
    return {
      ngModule: AuditModule,
      providers: [
        AuditsApiService,
        { provide: AuditConfigurationService, useValue: config },
      ],
    };
  }
}
